"use client";
import { QueryObserverResult, useQuery } from "@tanstack/react-query";
import { getAssets } from "@pulsex/services";
import { Menu } from "@pulsex/models";
import { IPulseXConfig } from "@pulsex/types";

export default function useMenus(config: IPulseXConfig) {
    const query: QueryObserverResult<any, Error> = useQuery({
        queryKey: ["GET_ASSETS"],
        queryFn: () => getAssets(config),
        refetchOnWindowFocus: false,
    });

    let menus: Menu | undefined;
    if (query.isSuccess && query.data) {
        menus = new Menu(query.data?.menus);
    }

    return {
        isLoading: query.isLoading,
        status: query.status,
        menus,
    };
}
